<template>
    <div class="columns is-multiline mgt-20px">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>{{ $t('produitDivers.produit') }}</p>
          </header>
          <div class="card-content">
            <div class="columns is-marginless is-paddingless is-multiline">
              <figure class="column is-2">
                <app-logo readOnly class="is-pulled-left"
               :elementId="produit.id"
               :libelleElement="$t('produitDivers.libelleProduitForLogo',
                  { ref: produit.reference })">
              </app-logo>
              </figure>
              <div class="column is-6">
                <div class="columns">
                  <div class="column is-6">
                    <p class="has-text-default is-italic is-size-7">
                      {{ $t('produitDivers.numero') + produit.reference }}
                    </p>
                    <p class="is-narrow is-size-4 has-text-weight-bold">{{ produit.libelle }}</p>
                  </div>
                </div>
                <br>
                <b-field class="columns">
                  <div class="column is-3">
                    <p class="has-text-default is-italic">{{ $t('produitDivers.tva')}}</p>
                    <p class="has-text-weight-semibold">
                      {{ produit.tauxTva + $t('produitDivers.pourcentage') }}
                    </p>
                  </div>
                  <div class="column is-3">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.quantites') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      {{ produit.produitDivers.quantite === null
                      ? '' : produit.produitDivers.quantite + ' '
                      + $t(findUniteVente) }}
                    </p>
                  </div>
                  <div class="column is-3">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.tlpe') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      <qd-checkbox v-model="produit.produitDivers.tlpe" disabled
                                  class="mgt-10px">
                      </qd-checkbox>
                    </p>
                  </div>
                  <div class="column is-3">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.honoraire') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      <qd-checkbox v-model="produit.produitDivers.honoraire" disabled
                                  class="mgt-10px">
                      </qd-checkbox>
                    </p>
                  </div>
                  <div class="column is-3" v-if="moduleStockTiersActive">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.stockable') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      <qd-checkbox v-model="produit.stockable" disabled
                      class="mgt-10px">
                      </qd-checkbox>
                    </p>
                  </div>
                  <div class="column is-3" v-if="ligneCommandeARenouvelerSpe">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.renouvelable') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      <qd-checkbox
                        v-model="produit.renouvelable"
                        class="mgt-10px"
                        disabled>
                      </qd-checkbox>
                    </p>
                  </div>
                  <div class="column is-3" v-if="modulePresseActive">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.commissionnable') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      <qd-checkbox v-model="produit.produitDivers.commissionnable" disabled
                                  class="mgt-10px">
                      </qd-checkbox>
                    </p>
                  </div>
                </b-field>
                <b-field class="columns">
                  <div class="column is-3">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.prixUnitaire') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      {{ produit.produitDivers.prixUnitaire | formatDevise }}
                    </p>
                  </div>
                  <div class="column is-3">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.categorieOperation') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      {{ $t(getLibelleCategorieOperation) }}
                    </p>
                  </div>
                  <div class="column is-3" v-if="societesInformations.length > 1">
                    <p class="has-text-default is-italic">
                      {{ $t('produitDivers.societe') }}
                    </p>
                    <p class="has-text-weight-bold is-narrow">
                      {{ getLibelleSociete }}
                    </p>
                  </div>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('detailCatalogue.comptabilite.title') }}
            </p>
          </header>
          <div class="card-content columns">
            <schema-comptable :objetAvecSchemaComptable="produit"
                              class="column is-8"
                              :isConsultation="true">
            </schema-comptable>
            <detail-compte-analytique :produit="produit"
                                      class="column is-4"
            ></detail-compte-analytique>
          </div>
        </div>
      </div>
      <produit-commentaire-vente-card
        v-if="!isProduitSensAchat"
        :produit="produit"
        class="column is-12 mgt-10px"
        isDetail/>
      <div class="column mgt-10px" :class="hasHolding ? 'is-6' : 'is-12'">
        <detail-edition-dcf :produit="produit"></detail-edition-dcf>
      </div>
      <div class="column is-6 mgt-10px" v-if="hasHolding || moduleStockTiersActive">
        <detail-produit-oppose-lie :produit-oppose="produit.produitOpposeLie"
                                   :isDivers="produit.produitDivers !== null">
        </detail-produit-oppose-lie>
      </div>
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>{{ $t('piecesJointes.attachments')}}</p>
          </header>
          <div class="card-content">
            <app-pieces-jointes :checkPermissions="checkPermissions(permCatalogue.maj)"
                                readOnly deletable autoSave :canAddPj="!produitWithHolding"/>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import { LISTE_UNITES, SENS_ACHAT } from '@/configuration/devisConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import schemaComptable from '@/components/general/schemaComptable';
import detailCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/detailCompteAnalytique';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import detailEditionDcf from '@/components/catalogue/produitGeneral/editionDcf/c_editionDcf';
import detailProduitOpposeLie from '@/components/catalogue/produitGeneral/produitOpposeLie/detailProduitOpposeLie';
import produitCommentaireVenteCard from '@/components/catalogue/produitGeneral/produitCommentaireVenteCard';
import { siteHasHolding, getIdSocieteHolding } from '@/services/general/holding';
import { CATEGORIE_OPERATION } from '@/configuration/catalogue/produitConf';
import messageErreur from '@/services/general/messageErreur';
import MixinParametreInterne from '@/mixins/parametreInterne';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  mixins: [MixinParametreInterne],
  name: 'CatalogueDetailProduitDiversProduit',
  props: {
    produit: Object,
  },
  data() {
    return {
      permCatalogue: CATALOGUE,
    };
  },
  components: {
    appLogo: Logo,
    appPiecesJointes: PiecesJointes,
    schemaComptable,
    detailCompteAnalytique,
    detailEditionDcf,
    detailProduitOpposeLie,
    produitCommentaireVenteCard,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    findUniteVente() {
      const uniteVente = LISTE_UNITES.find((typeRemise) => {
        return typeRemise.code === this.produit.produitDivers.uniteVente;
      });
      if (uniteVente) return uniteVente.libelleLight;
      return '';
    },
    produitWithHolding() {
      return (siteHasHolding() && this.produit
        && this.produit.supportCommercial.societeId !== this.societeActiveId);
    },
    hasHolding() {
      return siteHasHolding();
    },
    produitDiversFromHolding() {
      return (siteHasHolding() && this.produit
        && (this.societeActiveId !== this.produit.supportCommercial.societeId
        || this.produit.supportCommercial.societeId !== getIdSocieteHolding()));
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getLibelleSociete() {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === this.produit.supportCommercial.societeId;
      });
      if (societe) return societe.libelle;
      return '';
    },
    getLibelleCategorieOperation() {
      const find = CATEGORIE_OPERATION.find((categorie) => {
        return categorie.code === this.produit.categorieOperation;
      });
      return find ? find.libelle : '';
    },
    isProduitSensAchat() {
      return this.produit.sens === SENS_ACHAT;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
